import { useNavigate } from "react-router-dom";

const RefundAndCancellation = () => {
  const navigate = useNavigate();
  return (
    <div className="p-4 h-dvh flex flex-col bg-bg-grey">
      <div onClick={() => navigate(-1)}>
        <img src="/icons/backbtn.svg" alt="" />
      </div>
      <div className="mt-4 text-center text-20">Refund and Cancellation</div>
      <div className="mt-2 bg-white85 rounded-[10px] p-2 px-3 border-[2px] border-[#00000020] overflow-y-auto flex-1 text-[15px] leading-relaxed">
        <div>
          <h3 className="font-semibold mt-4 mb-2">Credit Refund</h3>
          <ul className="list-disc pl-4 mb-2">
            <li>
              Credit points called as Sangati Credits can be purchased by the
              Members/Users any number of times. Once the Credit Points are
              purchased, they are{" "}
              <strong>
                not refundable under any circumstances, whatsoever
              </strong>
              .
            </li>
            <li>
              In the event the member/user deletes the account, the Credit
              Points shall lapse and the amount shall be forfeited by the
              Company.
            </li>
            <li>
              If it is proven that your card was used fraudulently on our
              website your money will be refunded. Should you suspect credit
              card fraud, please contact us immediately and we will investigate.
            </li>
            <li>
              If your membership was terminated by reason of violation of our
              Terms &amp; Conditions and/or Privacy Policy, or at your request,
              you will not be entitled for any refund.
            </li>
          </ul>

          <h3 className="font-semibold mt-4 mb-2">Declaration</h3>
          <p>
            You understand the terms of payment, refund and cancellation and
            shall not claim any compensation, damages, refund, amounts from the
            Company for the services, under any circumstances whatsoever.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RefundAndCancellation;
